module.exports = __webpack_public_path__ + "static/media/buy-sell.4db4739d.png";